import React from 'react';
import { MaskHappy, Users, ListNumbers, FileText, Tag } from '@phosphor-icons/react';

export default function PlayModule({ metadata, onChange }) {
  const handleChange = (field, value) => {
    onChange({ ...metadata, [field]: value });
  };

  return (
    <div className="space-y-6">
      {/* Synopsis */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <FileText size={16} />
          Synopsis (सारांश) <span className="text-red-500">*</span>
        </label>
        <textarea
          value={metadata.synopsis || ''}
          onChange={(e) => handleChange('synopsis', e.target.value)}
          placeholder="नाटक का संक्षिप्त सारांश लिखें..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={4}
        />
      </div>

      {/* Genre */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Genre (शैली)
        </label>
        <select
          value={metadata.genre || ''}
          onChange={(e) => handleChange('genre', e.target.value)}
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        >
          <option value="">Select genre...</option>
          <option value="tragedy">Tragedy (त्रासदी)</option>
          <option value="comedy">Comedy (कॉमेडी)</option>
          <option value="historical">Historical (ऐतिहासिक)</option>
          <option value="musical">Musical (संगीतमय)</option>
          <option value="social">Social Drama (सामाजिक नाटक)</option>
          <option value="experimental">Experimental (प्रयोगात्मक)</option>
        </select>
      </div>

      {/* Acts and Scenes */}
      <div className="grid grid-cols-2 gap-4">
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <ListNumbers size={16} />
            Number of Acts (अंक)
          </label>
          <input
            type="number"
            value={metadata.acts_count || ''}
            onChange={(e) => handleChange('acts_count', e.target.value)}
            placeholder="e.g., 3"
            min="1"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-2 flex items-center gap-2">
            <ListNumbers size={16} />
            Number of Scenes (दृश्य)
          </label>
          <input
            type="number"
            value={metadata.scenes_count || ''}
            onChange={(e) => handleChange('scenes_count', e.target.value)}
            placeholder="e.g., 12"
            min="1"
            className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
          />
        </div>
      </div>

      {/* Characters */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Users size={16} />
          Main Characters (मुख्य पात्र)
        </label>
        <textarea
          value={metadata.characters || ''}
          onChange={(e) => handleChange('characters', e.target.value)}
          placeholder="मुख्य पात्रों की सूची (हर पंक्ति में एक पात्र)..."
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors resize-none"
          rows={4}
        />
        <p className="text-xs text-muted-foreground mt-1">
          Format: Character Name - Brief description
        </p>
      </div>

      {/* Setting */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <MaskHappy size={16} />
          Setting (परिवेश)
        </label>
        <input
          type="text"
          value={metadata.setting || ''}
          onChange={(e) => handleChange('setting', e.target.value)}
          placeholder="Time period and location (e.g., 1947, Delhi)"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Duration */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <FileText size={16} />
          Performance Duration (प्रदर्शन अवधि)
        </label>
        <input
          type="text"
          value={metadata.duration || ''}
          onChange={(e) => handleChange('duration', e.target.value)}
          placeholder="e.g., 2 hours 30 minutes"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>

      {/* Theme */}
      <div>
        <label className="block text-sm font-medium mb-2 flex items-center gap-2">
          <Tag size={16} />
          Themes (विषय/मूल भाव)
        </label>
        <input
          type="text"
          value={metadata.themes || ''}
          onChange={(e) => handleChange('themes', e.target.value)}
          placeholder="Main themes (comma-separated)"
          className="w-full px-4 py-3 bg-background border border-border rounded-lg outline-none focus:border-primary transition-colors"
        />
      </div>
    </div>
  );
}
